// src/pages/FeedbackSurveyPage.js

import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import flashMessage from '../components/HelperFunctions';
import './Feedback.css';
import { logEvent } from '../utils/logger';

var SURVEYS = {
  post_call_1: {
    id: 'post_call_1',
    title: 'Quick question',
    question: 'What surprised you about that call?',
    placeholder: 'One sentence is fine',
    submitLabel: 'Send',
    skipLabel: 'Skip'
  }
  // Add more templates later:
  // post_call_2: { ... }
};

function Feedback() {
  var params = useParams();
  var surveyId = params.surveyId;

  var navigate = useNavigate();

  var survey = useMemo(function () {
    return SURVEYS[surveyId] || null;
  }, [surveyId]);

  var _useState = useState(''),
    answer = _useState[0],
    setAnswer = _useState[1];

  var _useState2 = useState(false),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];

  useEffect(function () {
    if (!survey) return;

    try {
      var event = {
        event: {
          label: 'PageView',
          data: { page: 'Feedback Survey Viewed: ' + survey.id }
        }
      };
      logEvent(event);
    } catch (e) {
      // no-op
    }
  }, [survey]);

  useEffect(function () {
    if (!survey) {
      navigate('/overview');
    }
  }, [survey, navigate]);

  async function handleSkip() {
    try {
      var jwt_token = localStorage.getItem('jwt_authorization');
      if (jwt_token && survey) {
        await axios.post(process.env.REACT_APP_BACKEND_HOST + '/feedback/skip', {
          jwt_token: jwt_token,
          survey_id: survey.id
        });
      }
    } catch (e) {
      // no-op
    } finally {
      navigate('/overview');
    }
  }

  async function handleSubmit() {
    var jwt_token = localStorage.getItem('jwt_authorization');
    if (!jwt_token) {
      navigate('/');
      return;
    }
    if (!survey) return;

    if (!answer || !answer.trim()) return;

    setIsSubmitting(true);
    try {
      await axios.post(process.env.REACT_APP_BACKEND_HOST + '/feedback', {
        jwt_token: jwt_token,
        survey_id: survey.id,
        question: survey.question,
        answer: answer.trim()
      });

      flashMessage('success', 'Thanks');

      try {
        var event = {
          event: {
            label: 'FeedbackSubmitted',
            data: { survey_id: survey.id }
          }
        };
        logEvent(event);
      } catch (e) {
        // no-op
      }

      navigate('/overview');
    } catch (error) {
      console.error('Failed to submit feedback:', error);
      flashMessage('error', 'Could not submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  }

  if (!survey) return null;

  return (
    <div className="feedback-page">
      <div className="feedback-card">
        <h1 className="feedback-title">{survey.title}</h1>
        <p className="feedback-question">{survey.question}</p>

        <textarea
          data-say-id="feedback-textarea"
          className="feedback-textarea"
          placeholder={survey.placeholder}
          value={answer}
          onChange={function (e) { setAnswer(e.target.value); }}
          disabled={isSubmitting}
          rows={5}
        />

        <div className="feedback-actions">
          <button
            data-say-id="feedback-skip-button"
            className="feedback-skip"
            onClick={handleSkip}
            disabled={isSubmitting}
            type="button"
          >
            {survey.skipLabel}
          </button>

          <button
            data-say-id="feedback-submit-button"
            className="feedback-submit"
            onClick={handleSubmit}
            disabled={isSubmitting || !answer.trim()}
            type="button"
          >
            {isSubmitting ? <div className="spinner"></div> : survey.submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
